module.exports = {
      id: "icon-open-in-new-usage",
      viewBox: "0 0 24.047 24.047",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-open-in-new",
      toString: function () {
        return this.url;
      }
    }